module.exports = __webpack_public_path__ + "static/media/9DESA28.94633b48.jpg";